

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { BeneficiaryDetails } from 'src/app/model/ngrx';


export const ADD_BENEFICIARY_DETAILS = '[BENEFICIARYDETAIL] Add';
export const REMOVE_BENEFICIARY_DETAILS = '[BENEFICIARYDETAIL] Remove';

// AddPersonalDetails
export class AddBeneficiaryDetails implements Action {
    readonly type =ADD_BENEFICIARY_DETAILS;

    constructor(public payload: BeneficiaryDetails) { }
}
// RemovePersonalDetails
export class RemoveBeneficiaryDetails implements Action {
    readonly type = REMOVE_BENEFICIARY_DETAILS;

    constructor(public payload: number) { }
}

export type Actions = AddBeneficiaryDetails | RemoveBeneficiaryDetails;
